import { compose, includes, toLower, pathOr } from "ramda";

const hasSingleSize = option =>
  compose(includes("single"), toLower(), pathOr("", ["Size", "value"]))(option);

export default hasSingleSize;
